;(function($) {

  /*
  $.ajaxPrefilter("script", function( options ) {
    options.cache = true;
  });
  $.ajaxPrefilter( "json", function( options ) {
    options.cache = true;
  });
  */

  var BEHAVIOUR_PREFIX = "bh",
  BEHAVIOUR = {};

  BEHAVIOUR.getScrollEnd = function()
  {
    var _this = $(this);

    function init() {
      if (_this.data('__getScrollEnd'))
        return;
      _this.data('__getScrollEnd',true);

      _this.on('scroll', function() {
        // console.log("scroll");
        // console.log($(this).scrollTop()+$(this).innerHeight());
        // console.log($(this)[0].scrollHeight);

        if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
          console.log('end reached');
          removeClass = _this.data("enable");
          $('.'+removeClass).removeClass('disabled');
        }
      })

      
    }
    init();
    return this;
  };

  $.fn.GUI = function()
  {
    for (var p in BEHAVIOUR)
    {
      $.fn[BEHAVIOUR_PREFIX + p] = BEHAVIOUR[p];
      $(this).find("." + BEHAVIOUR_PREFIX + "-" + p).each(function()
      {
        $(this)[BEHAVIOUR_PREFIX + p]();
      });
    }
    return this;
  };

  $.common = {};

  $.common.require = function(what)
  {
    //$.common.require('js/lib/jquery.fancybox.js');

    if (!$._requireLoaded)
      $._requireLoaded = [];
    if (!$._requireLoaded[what])
    {
      $._requireLoaded[what] = true;
      $("head").append('<script type="text/javascript" src="' + $.common.getBaseUri() + what + '"></script>');
    }
  };

  $.common.getBaseUri = function()
  {
    if (!$._baseUri)
    {
      var scriptSrc = $("head script.js").attr("src");
      scriptSrc = scriptSrc.split("\\").join("/");
      $._baseUri = scriptSrc.substring(0, scriptSrc.indexOf("/js/")) + "/";
      if ($._baseUri == "/")
        $._baseUri = "";
    }
    return $._baseUri;
  };


  $.utils = {};

  $.utils.setCookie = function(cname, cvalue, exdays, absolute) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    var value = cname + "=" + cvalue + "; " + expires;
    if (absolute)
      value += ";path=/";
    document.cookie = value;
  };

  $.utils.removeCookie = function(cname, absolute) {
    var value = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT ";
    if (absolute)
      value += ";path=/";
    document.cookie = value;
  };

  $.utils.getCookie = function(w){
    cName = "";
    pCOOKIES = new Array();
    pCOOKIES = document.cookie.split('; ');
    for(bb = 0; bb < pCOOKIES.length; bb++){
      NmeVal  = new Array();
      NmeVal  = pCOOKIES[bb].split('=');
      if(NmeVal[0] == w){
        cName = unescape(NmeVal[1]);
      }
    }
    return cName;
  };

  $(document).ready(function()
  {
    $('html').addClass('js').GUI();
  });


  // $(window).load(function()
  // {
  //  $.windowLoaded = true;
  // });

})(jQuery);